module.exports = __webpack_public_path__ + "img/no-data.95ec6a2c.png";